import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import React from 'react'
import { BlogNewIcon } from 'src/editor/shared/icons/blog-new-icon'
import { File04Icon } from 'src/editor/shared/icons/file-04-icon'
import { twMerge } from 'tailwind-merge'
import { PricingPageWhiteLabelIcon } from '../../icons/pricing-page-white-label-icon'
import { Loader } from '../loader'

export interface PageElementProps {
  name: string
  pageType: PageTypeEnum
  isActive?: boolean
  onClick?: (type: PageTypeEnum) => void
  endElement?: React.ReactNode
  isLoading?: boolean
}

const pageTypeIcons: Partial<Record<PageTypeEnum, React.ReactNode>> = {
  [PageTypeEnum.WebsiteHome]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteDefault]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteLayout]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteLogin]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsitePricing]: (
    <PricingPageWhiteLabelIcon className="fill-iconSecondary" />
  ),
  [PageTypeEnum.BlogHome]: <BlogNewIcon className="fill-iconSecondary" />,
}

export const PageElement = ({
  name,
  pageType,
  isActive,
  onClick,
  endElement,
  isLoading,
}: PageElementProps) => (
  <article
    onClick={() => onClick?.(pageType)}
    className={twMerge(
      'relative flex justify-between rounded-md p-3 transition-all duration-150 hover:bg-gray-50',
      isActive && 'bg-gray-50',
      onClick && 'cursor-pointer',
    )}
  >
    <div className="inline-flex flex-row items-center gap-1.5 [&>svg]:shrink-0">
      {pageTypeIcons[pageType] ?? <File04Icon className="fill-iconSecondary" />}
      <span className="wrap-anywhere text-M text-textPrimary">{name}</span>
      {isLoading && <Loader className="h-4 w-4" />}
    </div>
    {/** biome-ignore lint/a11y/noStaticElementInteractions: stop click propagation inside row action container */}
    <div onClick={e => e.stopPropagation()}>{endElement}</div>
  </article>
)
